import * as LaunchDarkly from 'launchdarkly-js-client-sdk';

import * as config from './config';

const getClientId = () => {
  const env = config.getEnvironment();

  switch (env) {
    case 'production':
      return '6227626a3eb897146bfdc2ac';
    case 'staging':
      return '6227626a3eb897146bfdc2ab';
    case 'dev':
      return '6776dada990b1c095b1b43c1';
  }
};

const getContext = (user: User | null): LaunchDarkly.LDContext => {
  if (!user) {
    return {
      kind: 'user',
      anonymous: true
    };
  }

  const context: LaunchDarkly.LDContext = {
    kind: 'multi',
    user: {
      key: user.id,
      kind: 'user',
      type: user.agencyId ? 'agent' : 'client',
      name: user.name,
      email: user.email
    }
  };

  if (user.agencyId) {
    context.agency = {
      kind: 'agency',
      key: user.agencyId,
      type: 'agency',
      name: user.agencyName
    };
  }

  if (user.accountId) {
    context.account = {
      kind: 'account',
      key: user.accountId,
      type: 'account',
      name: user.accountName
    };
  }

  return context;
};

let ldClient: LaunchDarkly.LDClient;

type User = {
  id: string;
  email: string;
  name: string;

  agencyId?: string;
  agencyName?: string;

  accountId?: string;
  accountName?: string;
};

export const initializeClient = async (user: User | null) => {
  ldClient = LaunchDarkly.initialize(getClientId(), getContext(user));
  try {
    await ldClient.waitForInitialization(5);
  } catch (error) {
    // TODO: send these errors to Sentry
    // eslint-disable-next-line no-console
    console.error('Failed to initialize LaunchDarkly client', error);
  }
  return ldClient;
};

const getJSONFlag = <T>(flagName: string, defaultValue?: T) => {
  const flag = ldClient.variation(flagName, defaultValue);
  return flag as T;
};

// Define functions to get flags
type HomePageConfiguration = {
  enabled: boolean;
};

export const getHomePageConfiguration = () =>
  getJSONFlag<HomePageConfiguration>('ais-homepage-configuration');
